/* MalaMind Collection Reviews Bridge V2.0
 * CWILL/Trustoo collection-card star rating helper.
 * The actual rating data/rendering remains owned by the CWILL/Trustoo app embed.
 */
(function () {
  'use strict';

  var SELECTOR = '.custom-vstar-rating-widget[data-malamind-trustoo-widget="true"]';
  var MAX_PULSES = 4;

  function isRendered(el) {
    if (!el) return true;
    if (el.children && el.children.length > 0) return true;
    var html = (el.innerHTML || '').trim();
    return html.length > 0;
  }

  function pulse(el) {
    if (!el || isRendered(el)) return;
    var n = parseInt(el.getAttribute('data-malamind-pulse') || '0', 10);
    if (n >= MAX_PULSES) return;

    /* Reinsert an empty official Trustoo placeholder. Apps that watch dynamic
       DOM additions will see the new node; if the app already rendered it,
       this function never touches it. */
    var fresh = document.createElement('div');
    fresh.className = 'custom-vstar-rating-widget';
    fresh.setAttribute('data-product-id', el.getAttribute('data-product-id') || '');
    fresh.setAttribute('data-malamind-trustoo-widget', 'true');
    fresh.setAttribute('data-malamind-pulse', String(n + 1));
    el.replaceWith(fresh);
  }

  function scan() {
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      if (!isRendered(nodes[i])) pulse(nodes[i]);
    }
  }

  function scheduleScans() {
    [0, 350, 900, 1800, 3200, 5500].forEach(function (delay) {
      window.setTimeout(scan, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleScans, { once: true });
  } else {
    scheduleScans();
  }

  window.addEventListener('load', scheduleScans, { once: true });
  document.addEventListener('shopify:section:load', scheduleScans);

  /* Covers infinite scroll / load-more collection cards. */
  if ('MutationObserver' in window) {
    var timer = null;
    var observer = new MutationObserver(function () {
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(scan, 80);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
